import { combineReducers } from 'redux';
import friendsReducer from './friendsSlice';
// 如果有其他的reducer，请在这里导入
// import anotherReducer from './anotherSlice';

const rootReducer = combineReducers({
  friends: friendsReducer,
  // 在这里添加其他的reducer
  // another: anotherReducer,
});

export default rootReducer;